import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Ana Sayfa', href: '#ana-sayfa' },
  { label: 'Hizmetlerimiz', href: '#hizmetlerimiz' },
  { label: 'Nasıl Çalışıyoruz?', href: '#nasil-calisiyoruz' },
  { label: 'Hizmet Bölgeleri', href: '#hizmet-bolgeleri' },
  { label: 'Neden VİAYPİİ?', href: '#neden-viaypii' },
  { label: 'Sık Sorulan Sorular', href: '#sss' },
  { label: 'İletişim', href: '#iletisim' },
];

const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

const instagramUrl = 'https://www.instagram.com/viaypii_temizlik';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#ana-sayfa" className="flex items-center gap-2 flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/4c8d84f1d3902d1f52aa38f7b26dac1d.jpeg"
              alt="VİAYPİİ Temizlik"
              className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover"
            />
            <span className={`font-display font-bold text-sm md:text-lg tracking-wide transition-colors ${
              scrolled ? 'text-navy' : 'text-white'
            }`}>
              VİAYPİİ TEMİZLİK
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-gold ${
                  scrolled ? 'text-navy/80' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className={`hidden sm:flex w-10 h-10 items-center justify-center rounded-md border transition-colors ${
                scrolled
                  ? 'border-navy/20 text-navy hover:bg-navy hover:text-white'
                  : 'border-white/30 text-white hover:bg-white hover:text-navy'
              }`}
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-gold hover:bg-gold-dark text-navy-dark font-semibold text-sm rounded-md transition-colors"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WHATSAPP'TAN TEKLİF AL</span>
            </a>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`lg:hidden p-2 rounded-md transition-colors ${
                scrolled ? 'text-navy' : 'text-white'
              }`}
              aria-label="Menü"
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 top-16 bg-white z-40 overflow-y-auto">
          <nav className="flex flex-col p-6 gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-navy font-medium text-base py-2 border-b border-warm-sand"
              >
                {link.label}
              </a>
            ))}
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 px-4 py-3 border border-navy/20 text-navy font-semibold rounded-md"
            >
              <i className="ri-instagram-line text-xl"></i>
              <span>INSTAGRAM</span>
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 flex items-center justify-center gap-2 px-4 py-3 bg-gold text-navy-dark font-semibold rounded-md"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WHATSAPP'TAN TEKLİF AL</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}